const body = document.body;
const desktopMegamenuMedia = window.matchMedia('(min-width: 1024px)');
const FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
const BACKGROUND_INERT_SELECTORS = [
  '#MainContent',
  'footer',
];
let activeFocusTrapContainer = null;
let previousBodyOverflow = '';
let previousBodyPosition = '';
let previousBodyTop = '';
let lockedScrollY = 0;
let lastDrawerTrigger = null;
let lastMegamenuTrigger = null;
let lastWishlistTrigger = null;
let megamenuHideTimer = null;
let previousDocumentOverflow = '';
let cartDrawerWasOpen = false;
let cartDrawerScrollY = 0;
let cartDrawerUtilityWasHidden = false;
let cartDrawerOpeningPending = false;
let lastNonOverlayScrollY = window.scrollY;
let mobileBottomNavResizeObserver = null;
const mobileBottomNavMedia = window.matchMedia('(max-width: 989px)');

function openConsentmoPreferences() {
  const officialPreferenceOpeners = [
    () => window.Consentmo?.openDialog?.('preferences'),
    () => window.Consentmo?.openPreferences?.(),
    () => window.consentmo?.openDialog?.('preferences'),
    () => window.consentmo?.openPreferences?.(),
  ];

  for (const openPreferences of officialPreferenceOpeners) {
    try {
      if (openPreferences()) return true;
    } catch (_error) {
      // Fall back to the rendered Consentmo widget below.
    }
  }

  const consentWidgets = document.querySelectorAll('csm-cookie-consent');

  for (const widget of consentWidgets) {
    const root = widget.shadowRoot || widget;
    const settingsButton =
      root.querySelector('.cc-settings, .isense-cc-settings, button[class*="settings"]') ||
      Array.from(root.querySelectorAll('button')).find((button) =>
        (button.textContent || '').trim().toLowerCase().includes('preferințe')
      );

    if (settingsButton instanceof HTMLButtonElement) {
      settingsButton.click();
      return true;
    }

    if (typeof widget.showPopover === 'function') {
      widget.showPopover();
      return true;
    }
  }

  return false;
}

function resetConsentmoConsentState() {
  const cookieNames = [
    'cookieconsent_status',
    'cookieconsent_preferences_disabled',
    '_tracking_consent',
    '_shopify_m',
    '_shopify_tm',
    '_shopify_tw',
  ];
  const hostParts = window.location.hostname.split('.');
  const domainCandidates = [
    window.location.hostname,
    hostParts.length > 1 ? `.${hostParts.slice(-2).join('.')}` : '',
  ].filter(Boolean);

  cookieNames.forEach((name) => {
    document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax`;
    domainCandidates.forEach((domain) => {
      document.cookie = `${name}=; Max-Age=0; path=/; domain=${domain}; SameSite=Lax`;
    });
  });

  try {
    [window.localStorage, window.sessionStorage].forEach((storage) => {
      if (!storage) return;

      Object.keys(storage)
        .filter((key) => /consentmo|cookieconsent|csm|tracking_consent/i.test(key))
        .forEach((key) => storage.removeItem(key));
    });
  } catch (_error) {
    // Storage access can be blocked by browser privacy modes; cookie reset still covers the main consent state.
  }
}

function scheduleConsentmoPreferenceRetry(button) {
  if (button instanceof HTMLElement) button.setAttribute('aria-busy', 'true');

  let attempts = 0;
  const retryTimer = window.setInterval(() => {
    attempts += 1;

    if (openConsentmoPreferences()) {
      window.clearInterval(retryTimer);
      if (button instanceof HTMLElement) button.removeAttribute('aria-busy');
      return;
    }

    if (attempts >= 12) {
      window.clearInterval(retryTimer);
      if (button instanceof HTMLElement) button.removeAttribute('aria-busy');
      resetConsentmoConsentState();
      window.location.hash = 'cookie-preferences';
      window.location.reload();
    }
  }, 250);
}

function bindCookiePreferenceButtons() {
  window.sealdiOpenCookiePreferences = openConsentmoPreferences;

  if (typeof window.showPreferences !== 'function') {
    window.showPreferences = openConsentmoPreferences;
  }

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target?.closest('.isense-reopen-widget-button, [data-sealdi-cookie-preferences]');

      if (!(button instanceof HTMLElement)) return;

      event.preventDefault();

      if (openConsentmoPreferences()) return;

      scheduleConsentmoPreferenceRetry(button);
    },
    true
  );

  if (window.location.hash === '#cookie-preferences') {
    scheduleConsentmoPreferenceRetry(null);
  }
}

document.addEventListener(
  'click',
  (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const toggle = target?.closest('[data-sealdi-megamenu-toggle]');
    if (!toggle || !desktopMegamenuMedia.matches) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    lastMegamenuTrigger = toggle;
    setMegamenuOpen(true);
  },
  true
);

function getSharedHeaderBottom() {
  const headerSection = document.querySelector('.sealdi-header-section--shared');
  if (!(headerSection instanceof HTMLElement)) return 96;
  return Math.max(0, Math.round(headerSection.getBoundingClientRect().bottom));
}

function updateSharedHeaderOffsets() {
  const headerBottom = getSharedHeaderBottom();
  document.documentElement.style.setProperty('--sealdi-shared-header-bottom', `${headerBottom}px`);
  document.documentElement.style.setProperty('--sealdi-megamenu-top', `${headerBottom + 10}px`);
}

function updateMegamenuPosition() {
  updateSharedHeaderOffsets();
}

function updateAccountPopupPosition() {
  const accountLink = Array.from(document.querySelectorAll('.sealdi-account-link--component')).find((node) => {
    if (!(node instanceof HTMLElement)) return false;
    const rect = node.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  });

  if (!(accountLink instanceof HTMLElement)) {
    document.documentElement.style.setProperty('--sealdi-account-popup-top', `${getSharedHeaderBottom() + 8}px`);
    return;
  }

  const rect = accountLink.getBoundingClientRect();
  document.documentElement.style.setProperty('--sealdi-account-popup-top', `${Math.max(0, Math.round(rect.bottom + 8))}px`);
}

function cancelMegamenuClose() {
  if (megamenuHideTimer) {
    window.clearTimeout(megamenuHideTimer);
    megamenuHideTimer = null;
  }
}

function scheduleMegamenuClose(delay = 70) {
  if (!desktopMegamenuMedia.matches || !body.classList.contains('sealdi-megamenu-open')) return;
  cancelMegamenuClose();
  megamenuHideTimer = window.setTimeout(() => {
    setMegamenuOpen(false);
  }, delay);
}

function isOverlayOpen() {
  return body.classList.contains('sealdi-drawer-open') || body.classList.contains('sealdi-wishlist-open') || body.classList.contains('sealdi-cart-open') || isCartDrawerOpen();
}

function syncOverlayState() {
  const open = isOverlayOpen();
  body.classList.toggle('sealdi-overlay-open', open);

  if (open) {
    if (!body.dataset.sealdiOverflowLocked) {
      previousBodyOverflow = body.style.overflow;
      previousDocumentOverflow = document.documentElement.style.overflow;
      body.dataset.sealdiOverflowLocked = 'true';
    }
    body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  } else {
    body.style.overflow = previousBodyOverflow;
    document.documentElement.style.overflow = previousDocumentOverflow;
    delete body.dataset.sealdiOverflowLocked;
  }

  BACKGROUND_INERT_SELECTORS.forEach((selector) => {
    document.querySelectorAll(selector).forEach((node) => {
      if (!(node instanceof HTMLElement)) return;

      if (open) {
        node.inert = true;
      } else {
        node.inert = false;
      }
    });
  });
}

function getFocusableElements(container) {
  if (!(container instanceof HTMLElement)) return [];
  return Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(
    (node) => node instanceof HTMLElement && !node.hasAttribute('hidden') && node.offsetParent !== null
  );
}

function setFocusTrap(container) {
  activeFocusTrapContainer = container instanceof HTMLElement ? container : null;
}

function trapFocus(event) {
  if (event.key !== 'Tab' || !activeFocusTrapContainer) return;
  const focusables = getFocusableElements(activeFocusTrapContainer);
  if (!focusables.length) return;

  const first = focusables[0];
  const last = focusables[focusables.length - 1];
  const active = document.activeElement;

  if (event.shiftKey) {
    if (active === first || !activeFocusTrapContainer.contains(active)) {
      event.preventDefault();
      last.focus();
    }
    return;
  }

  if (active === last || !activeFocusTrapContainer.contains(active)) {
    event.preventDefault();
    first.focus();
  }
}

function focusVisibleCloseButton(container, selector) {
  if (!(container instanceof HTMLElement)) return;

  const close = Array.from(container.querySelectorAll(selector)).find(
    (node) => node instanceof HTMLElement && !node.hasAttribute('hidden') && node.offsetParent !== null
  );

  if (!(close instanceof HTMLElement)) return;
  close.focus();
}

function focusFirstFocusable(container) {
  const [firstFocusable] = getFocusableElements(container);
  if (firstFocusable instanceof HTMLElement) {
    firstFocusable.focus();
  }
}

function setDrawerOpen(open) {
  if (open) {
    setWishlistDrawerOpen(false);
    closeCartDrawer();
  }

  body.classList.toggle('sealdi-drawer-open', open);
  document.querySelectorAll('[data-sealdi-drawer-toggle], [data-sealdi-drawer-open]').forEach((toggle) => {
    if (toggle instanceof HTMLElement) {
      toggle.setAttribute('aria-expanded', String(open));
    }
  });

  if (open) {
    const drawer = document.querySelector('#SealdiMobileCategoryDrawer');
    setFocusTrap(drawer instanceof HTMLElement ? drawer : null);
    syncMobileDrawerPanels();
    focusVisibleCloseButton(drawer, '[data-sealdi-drawer-close]');
  } else if (!body.classList.contains('sealdi-megamenu-open')) {
    setFocusTrap(null);
    if (lastDrawerTrigger instanceof HTMLElement) {
      lastDrawerTrigger.focus();
    }
  }

  syncOverlayState();
}

function closeCartDrawer() {
  document.querySelectorAll('cart-drawer-component').forEach((drawer) => {
    if (typeof drawer.close === 'function') drawer.close();
  });
  window.setTimeout(syncCartDrawerState, 0);
}

function updateMobileBottomNavMetrics() {
  const root = document.documentElement;
  const nav = document.querySelector('.sealdi-mobile-bottom-nav');
  // Fixed elements already follow the visual viewport on mobile browsers.
  // Adding the browser toolbar height again lifts the nav and leaves a gap.
  root.style.setProperty('--sealdi-mobile-browser-bottom', '0px');

  if (!mobileBottomNavMedia.matches || !(nav instanceof HTMLElement)) {
    root.style.setProperty('--sealdi-mobile-bottom-nav-height', '0px');
    return;
  }

  const navHeight = Math.max(nav.getBoundingClientRect().height, 0);
  root.style.setProperty('--sealdi-mobile-bottom-nav-height', `${navHeight}px`);
}

function getPreferredCartDrawer() {
  const drawers = Array.from(document.querySelectorAll('cart-drawer-component'));
  if (!drawers.length) return null;

  return drawers.find((drawer) => drawer.querySelector('[data-testid="cart-drawer-dialog"]')) || drawers[0];
}

function openCartDrawer(drawerOverride = null) {
  const cartDrawer = drawerOverride || getPreferredCartDrawer();
  if (cartDrawer && typeof cartDrawer.open === 'function') {
    rememberCartDrawerStateBeforeOpen();
    cartDrawer.open();
    window.requestAnimationFrame(syncCartDrawerState);
    return true;
  }
  return false;
}

function isCartDrawerOpen() {
  return Array.from(document.querySelectorAll('cart-drawer-component dialog')).some(
    (dialog) => dialog instanceof HTMLDialogElement && dialog.open
  );
}

function rememberCartDrawerStateBeforeOpen() {
  cartDrawerOpeningPending = true;
  cartDrawerScrollY = Math.max(window.scrollY, lastNonOverlayScrollY);
  cartDrawerUtilityWasHidden = body.classList.contains('sealdi-utility-hidden') || body.classList.contains('sealdi-home-utility-hidden');
}

function syncCartDrawerState() {
  const isOpen = isCartDrawerOpen();

  if (isOpen && !cartDrawerWasOpen && cartDrawerScrollY <= 0 && window.scrollY > 0) {
    cartDrawerScrollY = window.scrollY;
  }

  body.classList.toggle('sealdi-cart-open', isOpen);

  if (isOpen) {
    cartDrawerOpeningPending = false;

    if (cartDrawerUtilityWasHidden || cartDrawerScrollY > 72) {
      body.classList.add('sealdi-home-utility-hidden', 'sealdi-utility-hidden');
    }

    body.classList.remove('sealdi-drawer-open', 'sealdi-wishlist-open');
    document.querySelectorAll('[data-sealdi-wishlist-open], [data-sealdi-drawer-toggle], [data-sealdi-drawer-open]').forEach((toggle) => {
      if (toggle instanceof HTMLElement) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  syncOverlayState();

  if (!isOpen && cartDrawerWasOpen && cartDrawerScrollY > 0) {
    const restoreY = cartDrawerScrollY;
    const restoreScroll = () => {
      window.scrollTo(0, restoreY);
      lastNonOverlayScrollY = restoreY;
      if (cartDrawerUtilityWasHidden || restoreY > 72) {
        body.classList.add('sealdi-home-utility-hidden', 'sealdi-utility-hidden');
      }
    };

    window.requestAnimationFrame(restoreScroll);
    window.setTimeout(restoreScroll, 80);
    window.setTimeout(restoreScroll, 240);
    window.setTimeout(restoreScroll, 650);
  }

  cartDrawerWasOpen = isOpen;

  if (!isOpen) {
    cartDrawerOpeningPending = false;
  }
}

function setMegamenuOpen(open) {
  const menus = Array.from(document.querySelectorAll('[data-sealdi-megamenu]')).filter((menu) => menu instanceof HTMLElement);
  const backdrops = Array.from(document.querySelectorAll('[data-sealdi-megamenu-backdrop]')).filter(
    (backdrop) => backdrop instanceof HTMLElement
  );

  cancelMegamenuClose();

  if (open) {
    setDrawerOpen(false);
    setWishlistDrawerOpen(false);
    closeCartDrawer();
    body.classList.add('sealdi-megamenu-open');
    updateMegamenuPosition();
    backdrops.forEach((backdrop) => {
      backdrop.hidden = false;
      backdrop.setAttribute('data-state', 'closed');
    });
    menus.forEach((menu) => {
      menu.hidden = false;
      menu.setAttribute('aria-hidden', 'false');
      menu.setAttribute('data-state', 'closed');
    });
    window.requestAnimationFrame(() => {
      if (!body.classList.contains('sealdi-megamenu-open')) return;
      updateMegamenuPosition();
      backdrops.forEach((backdrop) => {
        backdrop.setAttribute('data-state', 'open');
      });
      menus.forEach((menu) => {
        menu.setAttribute('data-state', 'open');
      });
    });
  } else {
    body.classList.remove('sealdi-megamenu-open');
    backdrops.forEach((backdrop) => {
      backdrop.setAttribute('data-state', 'closed');
    });
    menus.forEach((menu) => {
      menu.setAttribute('aria-hidden', 'true');
      menu.setAttribute('data-state', 'closed');
    });

    megamenuHideTimer = window.setTimeout(() => {
      if (body.classList.contains('sealdi-megamenu-open')) return;
      backdrops.forEach((backdrop) => {
        backdrop.hidden = true;
      });
      menus.forEach((menu) => {
        menu.hidden = true;
      });
    }, 120);
  }

  document.querySelectorAll('[data-sealdi-megamenu-toggle]').forEach((toggle) => {
    if (toggle instanceof HTMLElement) {
      toggle.setAttribute('aria-expanded', String(open));
    }
  });

  if (open) {
    const menu = document.querySelector('[data-sealdi-megamenu]:not([hidden])') || document.querySelector('[data-sealdi-megamenu]');
    setFocusTrap(null);
  } else if (!body.classList.contains('sealdi-drawer-open')) {
    setFocusTrap(null);
    if (lastMegamenuTrigger instanceof HTMLElement) {
      lastMegamenuTrigger.focus();
    }
  }
}

function setActiveMegamenuPanel(index) {
  document.querySelectorAll('[data-sealdi-megamenu-tab]').forEach((tab) => {
    if (!(tab instanceof HTMLButtonElement)) return;
    const isActive = tab.dataset.sealdiMegamenuTab === String(index);
    tab.classList.toggle('is-active', isActive);
    tab.setAttribute('aria-selected', String(isActive));
    tab.tabIndex = isActive ? 0 : -1;
  });

  document.querySelectorAll('[data-sealdi-megamenu-panel]').forEach((panel) => {
    if (!(panel instanceof HTMLElement)) return;
    const isActive = panel.dataset.sealdiMegamenuPanel === String(index);
    panel.classList.toggle('is-active', isActive);
    panel.hidden = !isActive;
    if (isActive) {
      panel.scrollTop = 0;
      panel.querySelectorAll(
        '[data-sealdi-megamenu-context], [data-sealdi-megamenu-subcategories], .sealdi-megamenu__context, .sealdi-megamenu__subcategories'
      ).forEach((node) => {
        if (node instanceof HTMLElement) node.scrollTop = 0;
      });
    }
  });
}

function syncMobileDrawerPanels(activeIndex = null) {
  const root = document.querySelector('[data-sealdi-drawer-root]');
  const showRoot = activeIndex === null;

  if (root instanceof HTMLElement) {
    root.hidden = !showRoot;
  }

  document.querySelectorAll('[data-sealdi-drawer-category-button]').forEach((button) => {
    if (!(button instanceof HTMLButtonElement)) return;
    const isActive = activeIndex !== null && button.dataset.sealdiDrawerCategoryButton === String(activeIndex);
    button.setAttribute('aria-expanded', String(isActive));
  });

  document.querySelectorAll('[data-sealdi-drawer-panel]').forEach((panel) => {
    if (!(panel instanceof HTMLElement)) return;
    const isActive = activeIndex !== null && panel.dataset.sealdiDrawerPanel === String(activeIndex);
    panel.hidden = !isActive;
    if (isActive) panel.scrollTop = 0;
  });
}

const SealdiWishlist = {
  storageKey: 'sealdi-wishlist-v1',

  read() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey) || '[]');
    } catch {
      return [];
    }
  },

  write(items) {
    localStorage.setItem(this.storageKey, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('sealdi:wishlist-changed', { detail: items }));
  },

  has(handle) {
    return this.read().some((item) => item.handle === handle);
  },

  toggle(item) {
    const items = this.read();
    const index = items.findIndex((entry) => entry.handle === item.handle);
    if (index >= 0) {
      items.splice(index, 1);
    } else {
      items.unshift(item);
    }
    this.write(items);
  },
};

window.sealdiWishlist = SealdiWishlist;

function escapeHtml(value = '') {
  return String(value).replace(/[&<>"']/g, (char) => {
    const entities = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;',
    };
    return entities[char] || char;
  });
}

function updateWishlistUi(items = SealdiWishlist.read()) {
  const handles = new Set(items.map((item) => item.handle));

  document.querySelectorAll('[data-sealdi-wishlist-count]').forEach((node) => {
    node.textContent = String(items.length);
    node.hidden = items.length === 0;
  });

  document.querySelectorAll('[data-sealdi-wishlist-toggle]').forEach((button) => {
    if (!(button instanceof HTMLButtonElement)) return;
    const isActive = handles.has(button.dataset.productHandle);
    button.setAttribute('aria-pressed', String(isActive));
    button.setAttribute('aria-label', isActive ? 'Elimină de la favorite' : 'Salvează la favorite');
    button.classList.toggle('is-active', isActive);
  });
}

function renderWishlistItems(items = SealdiWishlist.read()) {
  if (!items.length) {
    return `
      <div class="sealdi-wishlist-empty">
        <h2>Nu sunt produse salvate</h2>
        <p>Produsele marcate cu inimă apar aici pentru comparație rapidă înainte de comandă.</p>
        <div class="sealdi-wishlist-empty__actions">
          <a class="button" href="/collections">Vezi categoriile</a>
          <a class="button button-secondary" href="/collections/oferte-speciale">Vezi ofertele</a>
        </div>
      </div>
    `;
  }

  return items
    .map((item) => {
      const title = escapeHtml(item.title || 'Produs salvat');
      const url = escapeHtml(item.url || '/collections/all');
      const image = escapeHtml(item.image || '');
      const price = escapeHtml(item.price || '');
      const handle = escapeHtml(item.handle || '');

      return `
        <article class="sealdi-wishlist-card">
          ${image ? `<a href="${url}" class="sealdi-wishlist-card__image"><img src="${image}" alt="${title}" loading="lazy"></a>` : ''}
          <div class="sealdi-wishlist-card__content">
            <h3><a href="${url}">${title}</a></h3>
            ${price ? `<p>${price}</p>` : ''}
            <div class="sealdi-wishlist-card__actions">
              <a class="button button-secondary" href="${url}">Vezi produsul</a>
              <button type="button" class="button button-unstyled" data-sealdi-wishlist-remove="${handle}">Elimină</button>
            </div>
          </div>
        </article>
      `;
    })
    .join('');
}

function renderWishlistDrawer(items = SealdiWishlist.read()) {
  const container = document.querySelector('[data-sealdi-wishlist-drawer-content]');
  if (!(container instanceof HTMLElement)) return;
  container.innerHTML = renderWishlistItems(items);
}

function setWishlistDrawerOpen(open) {
  const drawer = document.querySelector('[data-sealdi-wishlist-drawer]');
  const backdrop = document.querySelector('[data-sealdi-wishlist-close].sealdi-wishlist-drawer__backdrop');
  if (!(drawer instanceof HTMLElement)) return;

  if (open) {
    setDrawerOpen(false);
    closeCartDrawer();
    renderWishlistDrawer();
    drawer.hidden = false;
    if (backdrop instanceof HTMLElement) backdrop.hidden = false;
    body.classList.add('sealdi-wishlist-open');
    document.querySelectorAll('[data-sealdi-wishlist-open]').forEach((toggle) => {
      if (toggle instanceof HTMLElement) toggle.setAttribute('aria-expanded', 'true');
    });
    setFocusTrap(drawer);
    syncOverlayState();
    window.requestAnimationFrame(() => {
      drawer.setAttribute('data-state', 'open');
      if (backdrop instanceof HTMLElement) backdrop.setAttribute('data-state', 'open');
      focusVisibleCloseButton(drawer, '[data-sealdi-wishlist-close]');
    });
    return;
  }

  body.classList.remove('sealdi-wishlist-open');
  drawer.setAttribute('data-state', 'closed');
  if (backdrop instanceof HTMLElement) backdrop.setAttribute('data-state', 'closed');
  document.querySelectorAll('[data-sealdi-wishlist-open]').forEach((toggle) => {
    if (toggle instanceof HTMLElement) toggle.setAttribute('aria-expanded', 'false');
  });

  window.setTimeout(() => {
    if (body.classList.contains('sealdi-wishlist-open')) return;
    drawer.hidden = true;
    if (backdrop instanceof HTMLElement) backdrop.hidden = true;
  }, 180);

  if (!body.classList.contains('sealdi-drawer-open')) {
    setFocusTrap(null);
    if (lastWishlistTrigger instanceof HTMLElement) lastWishlistTrigger.focus();
  }

  syncOverlayState();
}

function bindWishlistButtons() {
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target.closest('[data-sealdi-wishlist-toggle]') : null;
    if (!(target instanceof HTMLButtonElement)) return;

    event.preventDefault();
    event.stopPropagation();

    const item = {
      id: target.dataset.productId,
      handle: target.dataset.productHandle,
      title: target.dataset.productTitle,
      url: target.dataset.productUrl,
      image: target.dataset.productImage,
      price: target.dataset.productPrice,
    };

    SealdiWishlist.toggle(item);
  });

  document.addEventListener('sealdi:wishlist-changed', (event) => {
    updateWishlistUi(event.detail);
    renderWishlistDrawer(event.detail);
    renderWishlistPage(event.detail);
  });
}

function updateMobileCartCount(count) {
  const parsedCount = Number(count) || 0;

  document.querySelectorAll('[data-testid="cart-drawer-trigger"]').forEach((trigger) => {
    if (trigger instanceof HTMLElement) {
      trigger.setAttribute('aria-label', `Coș ${parsedCount}`);
    }
  });

  document.querySelectorAll('.cart-drawer__dialog').forEach((dialog) => {
    if (dialog instanceof HTMLElement) {
      dialog.classList.toggle('cart-drawer--empty', parsedCount === 0);
    }
  });

  document.querySelectorAll('.sealdi-mobile-cart-count').forEach((node) => {
    if (!(node instanceof HTMLElement)) return;
    node.textContent = String(parsedCount);
    node.classList.toggle('is-empty', parsedCount === 0);
    node.setAttribute('aria-hidden', parsedCount === 0 ? 'true' : 'false');
    const mobileCartLink = node.closest('[data-sealdi-mobile-cart]');
    if (mobileCartLink instanceof HTMLElement) {
      mobileCartLink.setAttribute('aria-label', `${parsedCount} Coș`);
    }
  });
}

function getCartSectionIds() {
  const sectionIds = new Set();
  document.querySelectorAll('cart-items-component').forEach((item) => {
    if (item instanceof HTMLElement && item.dataset.sectionId) {
      sectionIds.add(item.dataset.sectionId);
    }
  });
  return Array.from(sectionIds);
}

async function fetchCartState() {
  const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
  if (!response.ok) {
    throw new Error('Cart state request failed');
  }
  return response.json();
}

async function refreshMobileCartCount() {
  try {
    const cart = await fetchCartState();
    updateMobileCartCount(cart?.item_count);
  } catch {
    // Header count is progressive enhancement; cart functionality remains handled by Shopify.
  }
}

function dispatchCartUpdateEvent(cart, sections = {}, source = 'sealdi-fallback-add-to-cart') {
  document.dispatchEvent(
    new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: source,
        data: {
          itemCount: Number(cart?.item_count) || 0,
          source,
          sections,
        },
      },
    })
  );
}

function runFallbackAddToCartAnimation(form, submitButton) {
  if (!customElements.get('fly-to-cart')) return;

  const cartDestination = document.querySelector('.header-actions__cart-icon') || document.querySelector('[data-sealdi-mobile-cart]');
  if (!(cartDestination instanceof Element)) return;

  const context = form.closest(
    '.sealdi-homepage__product-card, .product-card, .resource-card, .product, .card, .shopify-section'
  );
  const productImage = context?.querySelector('img');
  const imageUrl =
    productImage instanceof HTMLImageElement ? productImage.currentSrc || productImage.src || '' : '';

  if (!imageUrl) return;

  const source =
    submitButton instanceof Element
      ? submitButton
      : productImage instanceof Element
        ? productImage
        : null;

  if (!(source instanceof Element)) return;

  const flyToCartElement = document.createElement('fly-to-cart');
  flyToCartElement.classList.add('fly-to-cart--quick');
  flyToCartElement.style.setProperty('background-image', `url(${imageUrl})`);
  flyToCartElement.style.setProperty('--start-opacity', '0');
  flyToCartElement.source = source;
  flyToCartElement.destination = cartDestination;

  document.body.appendChild(flyToCartElement);
}

function bindFallbackAddToCartForms() {
  document.addEventListener('submit', async (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('form[action*="/cart/add"], form[data-type="add-to-cart-form"]')) return;
    if (event.defaultPrevented) return;
    if (form.closest('product-form-component')) return;

    event.preventDefault();

    const submitButton = event.submitter instanceof HTMLButtonElement || event.submitter instanceof HTMLInputElement
      ? event.submitter
      : form.querySelector('button[type="submit"], button:not([type]), input[type="submit"]');
    const previousDisabled = submitButton instanceof HTMLElement ? submitButton.hasAttribute('disabled') : false;

    if (submitButton instanceof HTMLElement) {
      submitButton.setAttribute('disabled', 'disabled');
      submitButton.setAttribute('aria-busy', 'true');
    }

    try {
      const formData = new FormData(form);
      const sectionIds = getCartSectionIds();

      if (sectionIds.length) {
        formData.delete('sections');
        formData.append('sections', sectionIds.join(','));
      }

      const addUrl = window.Theme?.routes?.cart_add_url || '/cart/add.js';
      const response = await fetch(addUrl, {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
        },
      });

      const payload = await response.json();
      if (!response.ok || payload?.status) {
        return;
      }

      const cart = await fetchCartState();
      dispatchCartUpdateEvent(cart, payload?.sections || {});
      runFallbackAddToCartAnimation(form, submitButton);
      openCartDrawer();
    } catch {
      // Keep fallback submission silent; native form submission remains available if JS fails before this point.
    } finally {
      if (submitButton instanceof HTMLElement) {
        submitButton.setAttribute('aria-busy', 'false');
        if (!previousDisabled) {
          submitButton.removeAttribute('disabled');
        }
      }
    }
  });
}

function bindMobileCartCount() {
  const syncFromEvent = (event) => {
    const count = event?.detail?.resource?.item_count ?? event?.detail?.cart?.item_count;
    if (Number.isFinite(Number(count))) {
      updateMobileCartCount(count);
      return;
    }
    window.setTimeout(refreshMobileCartCount, 250);
  };

  document.addEventListener('cart:update', syncFromEvent);
  document.addEventListener('cart:add', syncFromEvent);

  document.addEventListener('submit', (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form?.matches('form[action*="/cart/add"], form[data-type="add-to-cart-form"]')) return;
    window.setTimeout(refreshMobileCartCount, 900);
  });

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target.closest('[ref="addToCartButton"], .add-to-cart-button') : null;
    if (!target) return;
    window.setTimeout(refreshMobileCartCount, 900);
  });

  refreshMobileCartCount();
}

function bindMobileNavDrawers() {
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target.closest('[data-sealdi-mobile-cart]') : null;
    if (!(target instanceof HTMLAnchorElement)) return;

    setDrawerOpen(false);
    setWishlistDrawerOpen(false);

    if (openCartDrawer()) {
      event.preventDefault();
    }
  });
}

function bindCartDrawerState() {
  const syncSoon = () => window.requestAnimationFrame(syncCartDrawerState);
  const rememberFromTrigger = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target?.closest('[data-testid="cart-drawer-trigger"], [data-sealdi-mobile-cart]')) return;
    rememberCartDrawerStateBeforeOpen();
  };

  document.querySelectorAll('cart-drawer-component dialog').forEach((dialog) => {
    if (!(dialog instanceof HTMLDialogElement)) return;

    dialog.addEventListener('close', syncSoon);
    dialog.addEventListener('cancel', syncSoon);

    const observer = new MutationObserver(syncSoon);
    observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
  });

  document.addEventListener('pointerdown', rememberFromTrigger, true);
  document.addEventListener('mousedown', rememberFromTrigger, true);

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target?.closest('[data-testid="cart-drawer-trigger"], [data-sealdi-mobile-cart]')) return;

      rememberCartDrawerStateBeforeOpen();
      setDrawerOpen(false);
      setWishlistDrawerOpen(false);
      window.setTimeout(syncCartDrawerState, 0);
    },
    true
  );

  document.addEventListener('cart:update', syncSoon);
  document.addEventListener('cart:add', syncSoon);
  window.addEventListener(
    'scroll',
    () => {
      if (cartDrawerOpeningPending || isOverlayOpen()) return;
      lastNonOverlayScrollY = window.scrollY;
    },
    { passive: true }
  );
  syncCartDrawerState();
}

function normalizeCachedHeaderMarkup() {
  ['SealdiMobileCategoryDrawer', 'SealdiWishlistDrawer'].forEach((id) => {
    const element = document.getElementById(id);
    if (!(element instanceof HTMLElement) || element.tagName !== 'ASIDE') return;

    const replacement = document.createElement('div');
    Array.from(element.attributes).forEach((attribute) => {
      replacement.setAttribute(attribute.name, attribute.value);
    });
    while (element.firstChild) {
      replacement.appendChild(element.firstChild);
    }
    element.replaceWith(replacement);
  });
}

function upgradeCachedCategoryImages() {
  [
    'hidroizolatii',
    'armatura',
    'zidarie',
    'invelitori',
    'sisteme-de-termoizolatii-si-gips-carton',
    'adezivi-mortare-sape-si-gleturi',
    'profile-si-accesorii',
    'amenajari-exterioare',
  ].forEach((handle) => {
    document
      .querySelectorAll(`img[src*="sealdi-collection-${handle}.png"], img[src*="sealdi-collection-${handle}.webp"]`)
      .forEach((image) => {
      if (!(image instanceof HTMLImageElement)) return;
      const targetAsset = Number.parseInt(image.getAttribute('width') || '0', 10) <= 520
        ? `sealdi-collection-${handle}-320.webp`
        : `sealdi-collection-${handle}.webp`;

      image.src = image.src
        .replace(`sealdi-collection-${handle}.png`, targetAsset)
        .replace(`sealdi-collection-${handle}.webp`, targetAsset);
    });
  });

  [1, 2, 3, 4].forEach((index) => {
    document.querySelectorAll(`img[src*="sealdi-home-slide-${index}.webp"]`).forEach((image) => {
      if (!(image instanceof HTMLImageElement)) return;
      image.src = image.src.replace(`sealdi-home-slide-${index}.webp`, `sealdi-home-slide-${index}-840.webp`);
      image.setAttribute('width', '840');
      image.setAttribute('height', '474');
    });
  });
}

function bindCategoryDrawer() {
  syncMobileDrawerPanels(null);

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    if (target.closest('[data-sealdi-drawer-toggle]')) {
      lastDrawerTrigger = target.closest('[data-sealdi-drawer-toggle]');
      setMegamenuOpen(false);
      setDrawerOpen(!body.classList.contains('sealdi-drawer-open'));
      return;
    }

    if (target.closest('[data-sealdi-drawer-open]')) {
      lastDrawerTrigger = target.closest('[data-sealdi-drawer-open]');
      setMegamenuOpen(false);
      setDrawerOpen(true);
      return;
    }

    if (target.closest('[data-sealdi-drawer-close]')) {
      setDrawerOpen(false);
      return;
    }

    const categoryButton = target.closest('[data-sealdi-drawer-category-button]');
    if (categoryButton instanceof HTMLButtonElement) {
      event.preventDefault();
      syncMobileDrawerPanels(categoryButton.dataset.sealdiDrawerCategoryButton || null);
      const activePanel = document.querySelector(
        `[data-sealdi-drawer-panel="${categoryButton.dataset.sealdiDrawerCategoryButton || ''}"]`
      );
      focusFirstFocusable(activePanel);
      return;
    }

    if (target.closest('[data-sealdi-drawer-back]')) {
      event.preventDefault();
      const activePanel = target.closest('[data-sealdi-drawer-panel]');
      const activeIndex = activePanel instanceof HTMLElement ? activePanel.dataset.sealdiDrawerPanel : null;
      syncMobileDrawerPanels(null);
      const restoreButton =
        activeIndex != null
          ? document.querySelector(`[data-sealdi-drawer-category-button="${activeIndex}"]`)
          : document.querySelector('[data-sealdi-drawer-category-button]');
      if (restoreButton instanceof HTMLElement) {
        restoreButton.focus();
      }
      return;
    }

    if (target.closest('.sealdi-category-drawer a')) {
      setDrawerOpen(false);
      return;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setDrawerOpen(false);
    }
  });
}

function bindMegamenu() {
  if (!document.querySelector('[data-sealdi-megamenu]')) return;

  const menuShell = document.querySelector('[data-sealdi-megamenu]');
  const headerSection = document.querySelector('.sealdi-header-section--shared');
  const backdrop = document.querySelector('[data-sealdi-megamenu-backdrop]');

  setActiveMegamenuPanel(0);

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const toggle = target?.closest('[data-sealdi-megamenu-toggle]');
      if (!toggle || !desktopMegamenuMedia.matches) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      lastMegamenuTrigger = toggle;
      setMegamenuOpen(true);
    },
    true
  );

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const toggle = target.closest('[data-sealdi-megamenu-toggle]');
    if (toggle) {
      if (!desktopMegamenuMedia.matches) return;
      event.preventDefault();
      lastMegamenuTrigger = toggle;
      setMegamenuOpen(true);
      return;
    }

    const tab = target.closest('[data-sealdi-megamenu-tab]');
    if (tab instanceof HTMLButtonElement) {
      setActiveMegamenuPanel(tab.dataset.sealdiMegamenuTab || '0');
      return;
    }

    if (body.classList.contains('sealdi-megamenu-open') && !target.closest('.sealdi-megamenu')) {
      setMegamenuOpen(false);
      return;
    }

    if (target.closest('.sealdi-megamenu a')) {
      setMegamenuOpen(false);
    }
  });

  document.addEventListener('pointerdown', (event) => {
    if (!body.classList.contains('sealdi-megamenu-open')) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (target.closest('[data-sealdi-megamenu-toggle]') || target.closest('.sealdi-megamenu')) return;
    if (headerSection instanceof HTMLElement && headerSection.contains(target)) return;
    setMegamenuOpen(false);
  });

  if (menuShell instanceof HTMLElement) {
    menuShell.addEventListener('mouseenter', () => {
      cancelMegamenuClose();
    });

    menuShell.addEventListener('mouseleave', (event) => {
      if (event.relatedTarget instanceof Node && headerSection instanceof HTMLElement && headerSection.contains(event.relatedTarget)) {
        return;
      }
      scheduleMegamenuClose(120);
    });
  }

  if (backdrop instanceof HTMLElement) {
    const closeFromBackdrop = () => {
      setMegamenuOpen(false);
    };

    backdrop.addEventListener('mouseenter', () => {
      scheduleMegamenuClose(80);
    });
    backdrop.addEventListener('pointerover', closeFromBackdrop);
    backdrop.addEventListener('pointerdown', closeFromBackdrop);
    backdrop.addEventListener('mousedown', closeFromBackdrop);
    backdrop.addEventListener('click', closeFromBackdrop);
  }

  if (headerSection instanceof HTMLElement) {
    headerSection.addEventListener('mouseleave', (event) => {
      if (!body.classList.contains('sealdi-megamenu-open')) return;
      if (event.relatedTarget instanceof Node && menuShell instanceof HTMLElement && menuShell.contains(event.relatedTarget)) {
        return;
      }
      scheduleMegamenuClose(120);
    });
  }

  document.querySelectorAll('[data-sealdi-megamenu-tab]').forEach((tab) => {
    if (!(tab instanceof HTMLButtonElement)) return;
    tab.addEventListener('mouseenter', () => {
      if (!desktopMegamenuMedia.matches) return;
      cancelMegamenuClose();
      setActiveMegamenuPanel(tab.dataset.sealdiMegamenuTab || '0');
    });

    tab.addEventListener('keydown', (event) => {
      const tabs = Array.from(document.querySelectorAll('[data-sealdi-megamenu-tab]')).filter(
        (node) => node instanceof HTMLButtonElement
      );
      const currentIndex = tabs.findIndex((node) => node === tab);
      if (currentIndex === -1) return;

      let nextIndex = null;
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % tabs.length;
      } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = tabs.length - 1;
      }

      if (nextIndex === null) return;

      event.preventDefault();
      const nextTab = tabs[nextIndex];
      if (!(nextTab instanceof HTMLButtonElement)) return;
      setActiveMegamenuPanel(nextTab.dataset.sealdiMegamenuTab || '0');
      nextTab.focus();
    });
  });

  desktopMegamenuMedia.addEventListener('change', (event) => {
    if (!event.matches) {
      setMegamenuOpen(false);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setMegamenuOpen(false);
    }
  });

  window.addEventListener('resize', () => {
    if (body.classList.contains('sealdi-megamenu-open')) updateMegamenuPosition();
  });

  window.addEventListener('scroll', () => {
    if (body.classList.contains('sealdi-megamenu-open')) updateMegamenuPosition();
  }, { passive: true });
}

function bindSharedHeaderOffsets() {
  updateSharedHeaderOffsets();
  window.addEventListener('resize', updateSharedHeaderOffsets, { passive: true });
  window.addEventListener('scroll', updateSharedHeaderOffsets, { passive: true });
}

function bindMobileBottomNavMetrics() {
  updateMobileBottomNavMetrics();
  window.addEventListener('resize', updateMobileBottomNavMetrics, { passive: true });
  window.addEventListener('orientationchange', updateMobileBottomNavMetrics, { passive: true });
  window.addEventListener('load', updateMobileBottomNavMetrics, { once: true });

  const nav = document.querySelector('.sealdi-mobile-bottom-nav');
  if ('ResizeObserver' in window && nav instanceof HTMLElement) {
    mobileBottomNavResizeObserver?.disconnect();
    mobileBottomNavResizeObserver = new ResizeObserver(updateMobileBottomNavMetrics);
    mobileBottomNavResizeObserver.observe(nav);
  }

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', updateMobileBottomNavMetrics, { passive: true });
  }
}

function bindAccountPopupPosition() {
  updateAccountPopupPosition();

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('.sealdi-account-link--component')) {
        updateAccountPopupPosition();
      }
    },
    true
  );

  document.addEventListener('focusin', (event) => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('.sealdi-account-link--component')) {
      updateAccountPopupPosition();
    }
  });

  window.addEventListener('resize', updateAccountPopupPosition, { passive: true });
  window.addEventListener('scroll', updateAccountPopupPosition, { passive: true });
}

function renderWishlistPage(items = SealdiWishlist.read()) {
  const container = document.querySelector('[data-sealdi-wishlist-page]');
  if (!(container instanceof HTMLElement)) return;

  container.innerHTML = renderWishlistItems(items);
}

function bindWishlistDrawerActions() {
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const openButton = target.closest('[data-sealdi-wishlist-open]');
    if (openButton instanceof HTMLElement) {
      event.preventDefault();
      lastWishlistTrigger = openButton;
      setMegamenuOpen(false);
      setWishlistDrawerOpen(true);
      return;
    }

    if (target.closest('[data-sealdi-wishlist-close]')) {
      event.preventDefault();
      setWishlistDrawerOpen(false);
      return;
    }

    const removeButton = target.closest('[data-sealdi-wishlist-remove]');
    if (!(removeButton instanceof HTMLButtonElement)) return;

    const handle = removeButton.dataset.sealdiWishlistRemove;
    const items = SealdiWishlist.read().filter((item) => item.handle !== handle);
    SealdiWishlist.write(items);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setWishlistDrawerOpen(false);
  });
}

function bindSearchForms() {
  document.querySelectorAll('[data-sealdi-search-form]').forEach((form, index) => {
    if (!(form instanceof HTMLFormElement)) return;

    const input = form.querySelector('[data-sealdi-search-input]');
    const results = form.querySelector('[data-sealdi-predictive-results]');
    const categorySelect = form.querySelector('[data-sealdi-category-select]');
    let timer;
    let requestToken = 0;

    form.addEventListener('submit', (event) => {
      const query = input instanceof HTMLInputElement ? input.value.trim() : '';
      const selectedUrl = categorySelect instanceof HTMLSelectElement ? categorySelect.value : '';

      if (!query && selectedUrl) {
        event.preventDefault();
        window.location.href = selectedUrl;
      }
    });

    if (!(input instanceof HTMLInputElement) || !(results instanceof HTMLElement)) return;

    if (!results.id) {
      results.id = `SealdiPredictiveSearchResults-${index + 1}`;
    }

    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('spellcheck', 'false');
    input.setAttribute('aria-controls', results.id);

    const setResultsOpen = (isOpen) => {
      results.hidden = !isOpen;
      form.classList.toggle('is-predictive-open', isOpen);
    };

    input.addEventListener('input', () => {
      clearTimeout(timer);
      const query = input.value.trim();

      if (query.length < 2) {
        requestToken += 1;
        results.innerHTML = '';
        setResultsOpen(false);
        return;
      }

      const currentRequestToken = ++requestToken;
      timer = window.setTimeout(async () => {
        const url = new URL(Theme.routes.predictive_search_url, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('section_id', 'predictive-search');

        try {
          const response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          const html = await response.text();
          if (currentRequestToken !== requestToken) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const source = doc.querySelector('#shopify-section-predictive-search');
          results.innerHTML = source ? source.innerHTML : '';
          results.scrollTop = 0;
          setResultsOpen(Boolean(results.innerHTML.trim()));
        } catch {
          if (currentRequestToken !== requestToken) return;
          setResultsOpen(false);
        }
      }, 180);
    });

    input.addEventListener('focus', () => {
      if (input.value.trim().length >= 2 && results.innerHTML.trim()) {
        setResultsOpen(true);
      }
    });

    input.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      setResultsOpen(false);
      input.blur();
    });

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Node)) return;
      if (!form.contains(event.target)) {
        setResultsOpen(false);
      }
    });
  });
}

function bindSearchFocusButtons() {
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target.closest('[data-sealdi-focus-search]') : null;
    if (!target) return;

    event.preventDefault();
    const searchInput = document.querySelector('.sealdi-header__home-search [data-sealdi-search-input], .sealdi-homepage__hero-search-band [data-sealdi-search-input]');
    if (searchInput instanceof HTMLInputElement) {
      searchInput.focus();
      searchInput.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  });
}

function bindProductCalculator() {
  document.querySelectorAll('[data-sealdi-calculator]').forEach((calculator) => {
    if (!(calculator instanceof HTMLElement)) return;

    const lengthInput = calculator.querySelector('[data-calc-length]');
    const widthInput = calculator.querySelector('[data-calc-width]');
    const areaNode = calculator.querySelector('[data-calc-area]');
    const coverageNode = calculator.querySelector('[data-calc-coverage]');
    const packagesNode = calculator.querySelector('[data-calc-packages]');
    const applyButton = calculator.querySelector('[data-calc-apply]');
    const quantityInput = document.querySelector('.product-details input[name=\"quantity\"]');

    const render = () => {
      const length = Number(lengthInput?.value || 0);
      const width = Number(widthInput?.value || 0);
      const coverage = Number(calculator.dataset.coverage || 0);

      const area = Math.max(length * width, 0);
      const packages = coverage > 0 && area > 0 ? Math.max(Math.ceil(area / coverage), 1) : 0;

      if (areaNode) areaNode.textContent = `${area.toFixed(area % 1 ? 1 : 0)} m²`;
      if (coverageNode) coverageNode.textContent = coverage > 0 ? `${coverage.toFixed(coverage % 1 ? 1 : 0)} m²` : '—';
      if (packagesNode) packagesNode.textContent = packages > 0 ? String(packages) : '—';
      if (applyButton instanceof HTMLButtonElement) {
        applyButton.textContent = packages > 0 ? 'Aplică cantitatea în coș' : 'Completează suprafața';
        applyButton.dataset.calculatedPackages = String(Math.max(packages, 1));
        applyButton.disabled = packages === 0;
      }
    };

    [lengthInput, widthInput].forEach((input) => {
      input?.addEventListener('input', render);
    });

    applyButton?.addEventListener('click', () => {
      if (quantityInput instanceof HTMLInputElement && applyButton instanceof HTMLButtonElement) {
        quantityInput.value = applyButton.dataset.calculatedPackages || '1';
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    render();
  });
}

function bindScrollableRails() {
  document.querySelectorAll('[data-sealdi-rail]').forEach((rail) => {
    if (!(rail instanceof HTMLElement)) return;
    const track = rail.querySelector('[data-sealdi-rail-track]');
    const previous = rail.parentElement?.querySelector('[data-sealdi-rail-prev]');
    const next = rail.parentElement?.querySelector('[data-sealdi-rail-next]');

    if (!(track instanceof HTMLElement)) return;

    const updateState = () => {
      const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
      previous?.toggleAttribute('disabled', track.scrollLeft <= 4);
      next?.toggleAttribute('disabled', track.scrollLeft >= maxScroll - 4);
    };

    const scrollByStep = (direction) => {
      const firstCard = track.firstElementChild;
      const gap = Number.parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || '0');
      const usesPageScroll = rail.dataset.sealdiRailScroll === 'page';
      const distance = usesPageScroll
        ? Math.max(Math.round(track.clientWidth * 0.86), 220)
        : firstCard instanceof HTMLElement
            ? Math.round(firstCard.getBoundingClientRect().width + gap)
            : 280;

      track.scrollBy({ left: distance * direction, behavior: 'smooth' });
    };

    previous?.addEventListener('click', () => scrollByStep(-1));
    next?.addEventListener('click', () => scrollByStep(1));
    track.addEventListener('scroll', updateState, { passive: true });
    window.addEventListener('resize', updateState, { passive: true });
    updateState();
  });
}

function bindHomeHeaderScroll() {
  const headerSection = document.querySelector('.sealdi-header-section--shared');
  if (!(headerSection instanceof HTMLElement)) return;

  let lastScrollY = window.scrollY;
  let hidden = false;
  let ticking = false;

  const render = () => {
    if (isOverlayOpen()) {
      ticking = false;
      return;
    }

    const currentY = window.scrollY;
    const nearTop = currentY <= 24;
    const goingDown = currentY > lastScrollY + 8;
    const goingUp = currentY < lastScrollY - 8;

    if (nearTop || goingUp) {
      hidden = false;
    } else if (goingDown && currentY > 72) {
      hidden = true;
    }

    body.classList.toggle('sealdi-home-utility-hidden', hidden);
    body.classList.toggle('sealdi-utility-hidden', hidden);
    lastScrollY = currentY;
    ticking = false;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(render);
    },
    { passive: true }
  );

  render();
}

function bindHomeCarousel() {
  const carousel = document.querySelector('[data-sealdi-home-carousel]');
  if (!(carousel instanceof HTMLElement)) return;

  const slides = Array.from(carousel.querySelectorAll('[data-sealdi-home-slide]')).filter((node) => node instanceof HTMLElement);
  if (slides.length < 2) return;

  const dots = Array.from(carousel.querySelectorAll('[data-sealdi-home-dot]')).filter((node) => node instanceof HTMLButtonElement);
  const previousButton = carousel.querySelector('[data-sealdi-home-prev]');
  const nextButton = carousel.querySelector('[data-sealdi-home-next]');
  const intervalMs = Number.parseInt(carousel.dataset.sealdiHomeCarouselInterval || '6000', 10);
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
  if (activeIndex < 0) activeIndex = 0;

  let autoplayTimer = null;
  let touchStartX = 0;
  let touchEndX = 0;

  const stopAutoplay = () => {
    if (autoplayTimer) {
      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  };

  const startAutoplay = () => {
    if (prefersReducedMotion || intervalMs < 1500) return;
    stopAutoplay();
    autoplayTimer = window.setInterval(() => {
      goToSlide(activeIndex + 1);
    }, intervalMs);
  };

  const setSlideInteractivity = (slide, isActive) => {
    slide.toggleAttribute('inert', !isActive);

    slide
      .querySelectorAll('a[href], button, input, select, textarea, [tabindex]')
      .forEach((element) => {
        if (!(element instanceof HTMLElement)) return;

        if (!isActive) {
          if (!Object.prototype.hasOwnProperty.call(element.dataset, 'sealdiOriginalTabindex')) {
            element.dataset.sealdiOriginalTabindex = element.getAttribute('tabindex') || '';
          }
          element.setAttribute('tabindex', '-1');
          return;
        }

        if (!Object.prototype.hasOwnProperty.call(element.dataset, 'sealdiOriginalTabindex')) return;

        const originalTabindex = element.dataset.sealdiOriginalTabindex;
        if (originalTabindex) {
          element.setAttribute('tabindex', originalTabindex);
        } else {
          element.removeAttribute('tabindex');
        }
        delete element.dataset.sealdiOriginalTabindex;
      });
  };

  const goToSlide = (nextIndex) => {
    const normalizedIndex = (nextIndex + slides.length) % slides.length;
    activeIndex = normalizedIndex;

    slides.forEach((slide, index) => {
      const isActive = index === normalizedIndex;
      if (isActive) slide.hidden = false;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', String(!isActive));
      setSlideInteractivity(slide, isActive);
      if (!isActive) {
        window.setTimeout(() => {
          if (!slide.classList.contains('is-active')) slide.hidden = true;
        }, 340);
      }
    });

    dots.forEach((dot, index) => {
      const isActive = index === normalizedIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', String(isActive));
    });
  };

  if (previousButton instanceof HTMLButtonElement) {
    previousButton.addEventListener('click', () => {
      goToSlide(activeIndex - 1);
      startAutoplay();
    });
  }

  if (nextButton instanceof HTMLButtonElement) {
    nextButton.addEventListener('click', () => {
      goToSlide(activeIndex + 1);
      startAutoplay();
    });
  }

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const nextIndex = Number.parseInt(dot.dataset.sealdiHomeDotIndex || '0', 10);
      goToSlide(nextIndex);
      startAutoplay();
    });
  });

  carousel.addEventListener('mouseenter', stopAutoplay);
  carousel.addEventListener('mouseleave', startAutoplay);

  carousel.addEventListener(
    'touchstart',
    (event) => {
      touchStartX = event.changedTouches[0]?.clientX || 0;
    },
    { passive: true }
  );

  carousel.addEventListener(
    'touchend',
    (event) => {
      touchEndX = event.changedTouches[0]?.clientX || 0;
      const delta = touchEndX - touchStartX;
      if (Math.abs(delta) < 36) return;
      if (delta > 0) {
        goToSlide(activeIndex - 1);
      } else {
        goToSlide(activeIndex + 1);
      }
      startAutoplay();
    },
    { passive: true }
  );

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stopAutoplay();
    } else {
      startAutoplay();
    }
  });

  goToSlide(activeIndex);
  startAutoplay();
}

function bindJudgeMeFallbacks() {
  const syncFallback = (wrapper) => {
    if (!(wrapper instanceof HTMLElement)) return;

    const widget = wrapper.querySelector('#judgeme_product_reviews');
    const fallback = wrapper.querySelector('[data-sealdi-judgeme-fallback]');

    if (!(widget instanceof HTMLElement) || !(fallback instanceof HTMLElement)) return;

    const hasRenderedWidget = Boolean(
      widget.querySelector(
        '.jm-review-widget, .jdgm-rev-widg, .jdgm-rev-widg__summary, .jdgm-rev-widg__title, .jdgm-write-rev-link, .jdgm-widget-actions-wrapper, .jdgm-row-stars, .jdgm-empty-state'
      )
    );

    const widgetText = widget.textContent || '';
    const isEmptyWidget = widgetText.includes('Fii primul') || widgetText.includes('Nicio recenzie') || widgetText.includes('0 recenzii');
    wrapper.classList.toggle('sealdi-judgeme-is-empty', isEmptyWidget);

    fallback.hidden = hasRenderedWidget;
  };

  document.querySelectorAll('[data-sealdi-judgeme-wrapper]').forEach((wrapper) => {
    if (!(wrapper instanceof HTMLElement)) return;

    syncFallback(wrapper);

    const widget = wrapper.querySelector('#judgeme_product_reviews');
    if (!(widget instanceof HTMLElement)) return;

    const observer = new MutationObserver(() => {
      syncFallback(wrapper);
    });

    observer.observe(widget, { childList: true, subtree: true });
    window.setTimeout(() => syncFallback(wrapper), 1200);
    window.setTimeout(() => syncFallback(wrapper), 3200);
  });
}

function init() {
  normalizeCachedHeaderMarkup();
  upgradeCachedCategoryImages();
  document.addEventListener('keydown', trapFocus);
  bindSharedHeaderOffsets();
  bindMobileBottomNavMetrics();
  updateWishlistUi();
  bindWishlistButtons();
  bindMobileCartCount();
  bindFallbackAddToCartForms();
  bindMobileNavDrawers();
  bindCartDrawerState();
  bindCategoryDrawer();
  bindMegamenu();
  bindAccountPopupPosition();
  bindWishlistDrawerActions();
  bindSearchForms();
  bindSearchFocusButtons();
  bindCookiePreferenceButtons();
  bindProductCalculator();
  bindScrollableRails();
  bindHomeHeaderScroll();
  bindHomeCarousel();
  bindJudgeMeFallbacks();
  renderWishlistDrawer();
  renderWishlistPage();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
